export default `/* Ids Rating Component */
.rating {
  align-items: center;
  display: inline-flex;
  flex-direction: row;
}
.rating span {
  display: none;
}

.star {
  cursor: pointer;
  margin-inline: var(--ids-rating-star-margin-inline);
}

.star[icon=star-outlined] {
  color: var(--ids-rating-star-color-default);
}
.star[icon=star-outlined]:hover {
  color: var(--ids-rating-star-color-hover);
}
.star[icon=star-outlined]:focus-visible {
  outline: none;
  color: var(--ids-rating-star-color-focus);
}

.star[icon=star-filled] {
  color: var(--ids-rating-star-color-selected);
}
.star[icon=star-filled]:hover {
  color: var(--ids-rating-star-color-hover);
}
.star[icon=star-filled]:focus-visible {
  outline: none;
  color: var(--ids-rating-star-color-focus);
}

.star[icon=star-half] {
  color: var(--ids-rating-star-color-selected);
}
.star[icon=star-half]:hover {
  color: var(--ids-rating-star-color-hover);
}
.star[icon=star-half]:focus-visible {
  outline: none;
  color: var(--ids-rating-star-color-focus);
}
.star[icon=star-half]:dir(rtl) {
  transform: scaleX(-1);
}

:host([readonly]) .star {
  cursor: default;
  pointer-events: none;
}

:host([disabled]) .star {
  cursor: default;
  pointer-events: none;
}
:host([disabled]) .star[icon] {
  color: var(--ids-rating-star-disabled-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
